import { KnownErrorModel } from '@interfaces/known-error.interface';
import { connector, environment } from '@env/environment';
import { enumRespErrors } from '@data-layer/enums/common';
import { HttpMethod } from '@enum/http-method';

export const knownErrors: () => KnownErrorModel[] = (): KnownErrorModel[] => {
  return [
    // Global
    {
      tag: enumRespErrors.AccessNotAllowed,
      errorText: 'KNOWN_ERRORS.ACCESS_NOT_ALLOWED',
      isGlobal: true,
    },
    {
      tag: enumRespErrors.EntityIsNotFound,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_NOT_FOUND',
      isGlobal: true,
    },
    {
      tag: enumRespErrors.DependenciesConflict,
      errorText: 'KNOWN_ERRORS.DEPENDENCIES_CONFLICT',
      isGlobal: true,
    },
    // Identity
    {
      tag: enumRespErrors.RecaptchaTokenInvalid,
      url: `${environment.url.user}`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CAPTCHA_TOKEN_INVALID',
    },
    {
      tag: enumRespErrors.RecaptchaTokenInvalid,
      url: `${environment.url.user}confirm-email`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CAPTCHA_TOKEN_INVALID',
    },
    {
      tag: enumRespErrors.EmailConfirmationFailed,
      url: `${environment.url.user}confirm-email`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.EMAIL_CONFIRMATION_FAILED',
    },
    {
      tag: enumRespErrors.DuplicateUserName,
      url: `${environment.url.user}`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.DUPLICATE_USER_NAME',
      isSkip: true,
    },
    {
      tag: enumRespErrors.EmailNotConfirmed,
      url: `${environment.url.user}reset-password`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.EMAIL_NOT_CONFIRMED',
      isSkip: true,
    },
    {
      tag: enumRespErrors.InvalidUsernameOrPassword,
      url: `${connector}`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVALID_USERNAME_OR_PASSWORD',
      isSkip: true,
    },
    {
      tag: enumRespErrors.AccountTemporarilyLocked,
      url: `${connector}`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ACCOUNT_TEMPORARILY_LOCKED',
      isSkip: true,
    },
    {
      tag: enumRespErrors.EmailNotConfirmed,
      url: `${connector}`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.EMAIL_NOT_CONFIRMED',
      isSkip: true,
    },
    // Freight
    {
      tag: enumRespErrors.ContainerNotFound,
      url: `${environment.url.prefixFreight}management/quotes/:id/containerId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.CONTAINER_NOT_FOUND',
    },
    {
      tag: enumRespErrors.AdminContactNotFound,
      url: `${environment.url.prefixFreight}management/agents/:agentId/contacts/:contactId`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ADMIN_CONTACT_NOT_FOUND',
    },
    {
      tag: enumRespErrors.VoyageIsNotFound,
      url: `${environment.url.prefixFreight}management/container-pricing-specifications`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.VOYAGE_IS_NOT_FOUND',
    },
    {
      tag: enumRespErrors.ContainerSpecificationNotFound,
      url: `${environment.url.prefixFreight}management/container-subcosts`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CONTAINER_SPECIFICATION_NOT_FOUND',
    },
    {
      tag: enumRespErrors.VoyageIsNotFound,
      url: `${environment.url.prefixFreight}management/voyage-options`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.VOYAGE_IS_NOT_FOUND',
    },
    {
      tag: enumRespErrors.ContainerHasDifferentVoyage,
      url: `${environment.url.prefixFreight}management/quotes/:id/containerId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.CONTAINER_HAS_DIFFERENT_VOYAGE',
    },
    {
      tag: enumRespErrors.QuoteIsAlreadyAtVoyage,
      url: `${environment.url.prefixFreight}quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.QUOTE_IS_ALREADY_AT_VOYAGE',
    },
    {
      tag: enumRespErrors.QuoteIsAlreadyAtVoyage,
      url: `${environment.url.prefixFreight}management/quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.QUOTE_IS_ALREADY_AT_VOYAGE',
    },
    {
      tag: enumRespErrors.RouteIsNotPublished,
      url: `${environment.url.prefixFreight}quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ROUTE_IS_NOT_PUBLISHED',
    },
    {
      tag: enumRespErrors.RouteIsNotPublished,
      url: `${environment.url.prefixFreight}management/quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ROUTE_IS_NOT_PUBLISHED',
    },
    {
      tag: enumRespErrors.VoyageIsNotPublished,
      url: `${environment.url.prefixFreight}quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.VOYAGE_IS_NOT_PUBLISHED',
    },
    {
      tag: enumRespErrors.VoyageIsNotPublished,
      url: `${environment.url.prefixFreight}management/quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.VOYAGE_IS_NOT_PUBLISHED',
    },
    {
      tag: enumRespErrors.ContainerCutoffValidationFailed,
      url: `${environment.url.prefixFreight}quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.CONTAINER_CUTOFF_VALIDATION_FAILED',
    },
    {
      tag: enumRespErrors.ContainerCutoffValidationFailed,
      url: `${environment.url.prefixFreight}management/quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.CONTAINER_CUTOFF_VALIDATION_FAILED',
    },
    {
      tag: enumRespErrors.DocumentsCutoffValidationFailed,
      url: `${environment.url.prefixFreight}quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.DOCUMENTS_CUTOFF_VALIDATION_FAILED',
    },
    {
      tag: enumRespErrors.DocumentsCutoffValidationFailed,
      url: `${environment.url.prefixFreight}management/quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.DOCUMENTS_CUTOFF_VALIDATION_FAILED',
    },
    {
      tag: enumRespErrors.WarehouseCutoffValidationFailed,
      url: `${environment.url.prefixFreight}quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WAREHOUSE_CUTOFF_VALIDATION_FAILED',
    },
    {
      tag: enumRespErrors.WarehouseCutoffValidationFailed,
      url: `${environment.url.prefixFreight}management/quotes/:id/voyageId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WAREHOUSE_CUTOFF_VALIDATION_FAILED',
    },
    {
      tag: enumRespErrors.AdditionalQuotePaymentIsAlreadyPayed,
      url: `${environment.url.prefixFreight}management/additional-quote-payments/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ADDITIONAL_QUOTE_PAYMENT_IS_ALREADY_PAYED',
    },
    {
      tag: enumRespErrors.CannotDetachDefaultContact,
      url: `${environment.url.prefixFreight}management/agents/:agentId/contacts/:contactId`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.CANNOT_DETACH_DEFAULT_CONTACT',
    },
    {
      tag: enumRespErrors.ContactAlreadyAttached,
      url: `${environment.url.prefixFreight}management/agents/:agentId/contacts/:contactId`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CONTACT_ALREADY_ATTACHED',
    },
    {
      tag: enumRespErrors.DefaultContactIsNotAttached,
      url: `${environment.url.prefixFreight}management/agents/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.DEFAULT_CONTACT_IS_NOT_ATTACHED',
    },
    {
      tag: enumRespErrors.AutoGeneratedContainerSpecification,
      url: `${environment.url.prefixFreight}management/container-pricing-specifications/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.AUTO_GENERATED_CONTAINER_SPECIFICATION',
    },
    {
      tag: enumRespErrors.SpecificationAlreadyExists,
      url: `${environment.url.prefixFreight}management/container-pricing-specifications`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.SPECIFICATION_ALREADY_EXISTS',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/container-pricing-specifications/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE_PRICING_SPECIFICATION',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/container-pricing-specifications/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE_PRICING_SPECIFICATION',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/container-pricing-specifications`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE_PRICING_SPECIFICATION',
    },
    {
      tag: enumRespErrors.AutoGeneratedContainerSpecification,
      url: `${environment.url.prefixFreight}management/voyages/:voyageId/containers`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.AUTO_GENERATED_CONTAINER_SPECIFICATION_CONTAINER',
    },
    {
      tag: enumRespErrors.AutoGeneratedContainerSpecification,
      url: `${environment.url.prefixFreight}management/containers/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.AUTO_GENERATED_CONTAINER_SPECIFICATION_CONTAINER',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/container-subcosts/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE_SUBCOST',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/container-subcosts/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE_SUBCOST',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/container-subcosts`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE_SUBCOST',
    },
    {
      tag: enumRespErrors.CannotChangeIsOptionalFlag,
      url: `${environment.url.prefixFreight}management/container-subcosts/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.CANNOT_CHANGE_ISOPTIONAL_FLAG_CONTAINER',
    },
    {
      tag: enumRespErrors.WrongPricingType,
      url: `${environment.url.prefixFreight}management/container-subcosts`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_PRICING_TYPE',
    },
    {
      tag: enumRespErrors.WrongPricingType,
      url: `${environment.url.prefixFreight}management/container-subcosts/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_PRICING_TYPE',
    },
    {
      tag: enumRespErrors.CannotRemoveDefaultEntity,
      url: `${environment.url.prefixFreight}management/container-types/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.CANNOT_REMOVE_DEFAULT_ENTITY_CONTAINER_TYPE',
    },
    {
      tag: enumRespErrors.SpecifiedSubcostsAreNotOptional,
      url: `${environment.url.prefixFreight}management/voyage-options`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.SPECIFIED_SUBCOSTS_ARE_NOT_OPTIONAL',
    },
    {
      tag: enumRespErrors.SpecifiedSubcostsAreNotOptional,
      url: `${environment.url.prefixFreight}management/voyage-options/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.SPECIFIED_SUBCOSTS_ARE_NOT_OPTIONAL',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/voyage-options`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/voyage-options/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE',
    },
    {
      tag: enumRespErrors.WrongVoyagePublishingState,
      url: `${environment.url.prefixFreight}management/voyage-options/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_VOYAGE_PUBLISHING_STATE',
    },
    // Cargo
    {
      tag: enumRespErrors.StatementIsNotFoundOnLds,
      url: `${environment.url.prefixCustoms}v2/management/statements/:id/resynchronize`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.STATEMENT_IS_NOT_FOUND_ON_LDS',
    },
    {
      tag: enumRespErrors.AdminContactNotFound,
      url: `${environment.url.prefixCustoms}v2/management/brokers/:brokerId/contacts/:contactId`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ADMIN_CONTACT_NOT_FOUND',
    },
    {
      tag: enumRespErrors.AdminContactNotFound,
      url: `${environment.url.prefixCustoms}v2/management/affiliates/:affiliateId/contacts/:contactId`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ADMIN_CONTACT_NOT_FOUND',
    },
    {
      tag: enumRespErrors.DiscountNotFound,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/pending-bills`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.DISCOUNT_NOT_FOUND',
      isSkip: true,
    },
    {
      tag: enumRespErrors.DiscountNotFound,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/bills`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.DISCOUNT_NOT_FOUND',
      isSkip: true,
    },
    {
      tag: enumRespErrors.LdsResponseContainedAnError,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-broker`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.LDS_RESPONSE_CONTAINED_AN_ERROR',
      isSkip: true,
    },
    {
      tag: enumRespErrors.LdsResponseContainedAnError,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/calculated`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.LDS_RESPONSE_CONTAINED_AN_ERROR',
      isSkip: true,
    },
    {
      tag: enumRespErrors.LdsResponseContainedAnError,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.LDS_RESPONSE_CONTAINED_AN_ERROR',
      isSkip: true,
    },
    {
      tag: enumRespErrors.LdsResponseContainedAnError,
      url: `${environment.url.prefixCustoms}v2/isfs/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.LDS_RESPONSE_CONTAINED_AN_ERROR',
      isSkip: true,
    },
    {
      tag: enumRespErrors.BondRequestWrongState,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.BOND_REQUEST_WRONG_STATE_ES',
    },
    {
      tag: enumRespErrors.BondRequestWrongState,
      url: `${environment.url.prefixCustoms}v2/isfs/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.BOND_REQUEST_WRONG_STATE_ISF',
    },
    {
      tag: enumRespErrors.IsfUnrecoverable,
      url: `${environment.url.prefixCustoms}v2/isfs/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ISF_UNRECOVERABLE',
    },
    {
      tag: enumRespErrors.PaymentFailed,
      url: `${environment.url.stripe}payment-intent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.PAYMENT_FAILED',
    },
    {
      tag: enumRespErrors.PaymentNotReady,
      url: `${environment.url.prefixCustoms}v2/payments/:paymentId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.PAYMENT_NOT_READY',
    },
    {
      tag: enumRespErrors.DiscountIsNotActive,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/pending-bills`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.DISCOUNT_IS_NOT_ACTIVE_COMPANY',
      isSkip: true,
    },
    {
      tag: enumRespErrors.DiscountUnauthorized,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/pending-bills`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.DISCOUNT_UNAUTHORIZED_COMPANY',
      isSkip: true,
    },
    {
      tag: enumRespErrors.DiscountUnauthorized,
      url: `${environment.url.prefixFreight}v2/companies/:companyId/pending-bills`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.DISCOUNT_UNAUTHORIZED_COMPANY',
      isSkip: true,
    },
    {
      tag: enumRespErrors.DiscountIsNotActive,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/bills`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.DISCOUNT_IS_NOT_ACTIVE_COMPANY',
    },
    {
      tag: enumRespErrors.DiscountUnauthorized,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/bills`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.DISCOUNT_UNAUTHORIZED_COMPANY',
      isSkip: true,
    },
    {
      tag: enumRespErrors.BondAlreadySent,
      url: `${environment.url.prefixCustoms}v2/bond-requests/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ALREADY_SENT',
    },
    {
      tag: enumRespErrors.BondAlreadySent,
      url: `${environment.url.prefixCustoms}v2/bond-requests/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ALREADY_SENT',
    },
    {
      tag: enumRespErrors.BondAlreadySent,
      url: `${environment.url.prefixCustoms}v2/bond-requests/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.REQUEST_NOT_VALID',
    },
    {
      tag: enumRespErrors.RequestNotValid,
      url: `${environment.url.prefixCustoms}v2/bond-requests/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.REQUEST_NOT_VALID',
    },
    {
      tag: enumRespErrors.BondNotFoundOrWrongState,
      url: `${environment.url.prefixCustoms}v2/management/bond-requests/:id/sync/data`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.BOND_NOT_FOUND_OR_WRONG_STATE',
    },
    {
      tag: enumRespErrors.BondAlreadySet,
      url: `${environment.url.prefixCustoms}v2/companies/:id/bond-request-id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ALREADY_SET',
    },
    {
      tag: enumRespErrors.BondAlreadySent,
      url: `${environment.url.prefixCustoms}v2/companies/:id/bond-request-id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ALREADY_SENT',
    },
    {
      tag: enumRespErrors.BondAlreadyPaid,
      url: `${environment.url.prefixCustoms}v2/companies/:id/bond-request-id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.BOND_BILL_IS_ALREADY_PAID',
    },
    {
      tag: enumRespErrors.InvalidState,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/self-filer/filer-code`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVALID_STATE_COMPANY',
    },
    {
      tag: enumRespErrors.InvalidState,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/self-filer/abi-transmitter-update-approved`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVALID_STATE_COMPANY',
    },
    {
      tag: enumRespErrors.InvalidState,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/self-filer/abi-transmitter-update-approved`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVALID_STATE_ABI',
    },
    {
      tag: enumRespErrors.ImporterRegistrationStartFailed,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:esId/registered-importers`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.IMPORTER_REGISTRATION_START_FAILED',
    },
    {
      tag: enumRespErrors.ImporterRegistrationStartFailed,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:esId/registered-consignees`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.IMPORTER_REGISTRATION_START_FAILED',
    },
    {
      tag: enumRespErrors.ImporterRegistrationStartFailed,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/registered-importers`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.IMPORTER_REGISTRATION_START_FAILED',
    },
    // #13269 — controlling persons (beneficial owners / partners)
    {
      tag: enumRespErrors.CompanyHasMissingFields,
      url: `${environment.url.companies}:companyId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.COMPANY_HAS_MISSING_FIELDS',
    },
    {
      tag: enumRespErrors.ControllingPersonDuplicated,
      url: `${environment.url.companies}:companyId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.CONTROLLING_PERSON_DUPLICATED',
    },
    {
      tag: enumRespErrors.ControllingPersonsIncomplete,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/digital-signs`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CONTROLLING_PERSONS_INCOMPLETE',
    },
    {
      tag: enumRespErrors.PartnershipTypeMissing,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/digital-signs`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.PARTNERSHIP_TYPE_MISSING',
    },
    {
      tag: enumRespErrors.ControllingPersonsIncomplete,
      url: `${environment.url.companiesV3}:companyId/bills`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CONTROLLING_PERSONS_INCOMPLETE',
    },
    {
      tag: enumRespErrors.PartnershipTypeMissing,
      url: `${environment.url.companiesV3}:companyId/bills`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.PARTNERSHIP_TYPE_MISSING',
    },
    {
      tag: enumRespErrors.ControllingPersonsIncomplete,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/registered-importers`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CONTROLLING_PERSONS_INCOMPLETE',
    },
    {
      tag: enumRespErrors.PartnershipTypeMissing,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/registered-importers`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.PARTNERSHIP_TYPE_MISSING',
    },
    {
      tag: enumRespErrors.ImporterRegistrationStartFailed,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:esId/registered-manufacturers`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.IMPORTER_REGISTRATION_START_FAILED',
    },
    {
      tag: enumRespErrors.ImporterRegistrationStartFailed,
      url: `${environment.url.prefixCustoms}v2/management/companies/:companyId/registered-importers`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.IMPORTER_REGISTRATION_START_FAILED',
    },
    {
      tag: enumRespErrors.FailedToChangePassword,
      url: `${environment.url.user}change-password`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.FAILED_TO_CHANGE_PASSWORD',
    },
    {
      tag: enumRespErrors.FileIsNotReady,
      url: `${environment.url.prefixCustoms}v2/documents/:id/data-url`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.FILE_IS_NOT_READY',
    },
    {
      tag: enumRespErrors.FileIsNotReady,
      url: `${environment.url.prefixCustoms}v2/documents/:id`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.FILE_IS_NOT_READY',
    },
    {
      tag: enumRespErrors.FileIsNotReady,
      url: `${environment.url.prefixCustoms}v2/documents/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.FILE_IS_NOT_READY',
    },
    {
      tag: enumRespErrors.FileIsNotReady,
      url: `${environment.url.prefixCustoms}v2/users`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.FILE_IS_NOT_READY',
    },
    {
      tag: enumRespErrors.FileIsNotReady,
      url: `${environment.url.prefixCustoms}v2/users-management/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.FILE_IS_NOT_READY',
    },
    {
      tag: enumRespErrors.EntityNotValid,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-broker`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ENTITY_NOT_VALID_ES',
    },
    {
      tag: enumRespErrors.NotPaid,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-broker`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.NOT_PAID_ES',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-broker`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ES',
    },
    {
      tag: enumRespErrors.NotPaid,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/confirm-broker-payment`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.NOT_PAID_ES',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/confirm-broker-payment`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ES',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-cbp`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ES',
    },
    {
      tag: enumRespErrors.NotPaid,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-cbp`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.NOT_PAID_ES',
    },
    {
      tag: enumRespErrors.NotUpToDate,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/broker/sent-to-cbp`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.NOT_PAID_ES',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ES',
    },
    {
      tag: enumRespErrors.EntityNotValid,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/calculated`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ENTITY_NOT_VALID_ES',
    },
    {
      tag: enumRespErrors.DatabaseNotSet,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/calculated`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.DATABASE_NOT_SET',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/calculated`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ES',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/calculated`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ES',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ES',
    },
    {
      tag: enumRespErrors.NotPaid,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.NOT_PAID_ES',
    },
    {
      tag: enumRespErrors.NotUpToDate,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.NOT_UP_TO_DATE_ES',
    },

    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/isfs/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ISF_DELETE',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/isfs/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_ISF',
    },
    {
      tag: enumRespErrors.NotPaid,
      url: `${environment.url.prefixCustoms}v2/isfs/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.NOT_PAID_ISF_SEND',
    },
    {
      tag: enumRespErrors.NotValid,
      url: `${environment.url.prefixCustoms}v2/isfs/sent`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.NOT_VALID_ISF_SEND',
    },
    {
      tag: enumRespErrors.CannotDetachDefaultContact,
      url: `${environment.url.prefixCustoms}v2/management/affiliates/:affiliateId/contacts/:contactId`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.CANNOT_DETACH_DEFAULT_CONTACT',
    },
    {
      tag: enumRespErrors.ContactAlreadyAttached,
      url: `${environment.url.prefixCustoms}v2/management/affiliates/:affiliateId/contacts/:contactId`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CONTACT_ALREADY_ATTACHED_AFFILIATE',
    },
    {
      tag: enumRespErrors.DefaultContactIsNotAttached,
      url: `${environment.url.prefixCustoms}v2/management/affiliates/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.DEFAULT_CONTACT_IS_NOT_ATTACHED_AFFILIATE',
    },
    {
      tag: enumRespErrors.WrongEntityState,
      url: `${environment.url.prefixCustoms}v2/management/bond-requests/:id/state`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_ENTITY_STATE',
    },
    {
      tag: enumRespErrors.WrongBondTypeToChangeState,
      url: `${environment.url.prefixCustoms}v2/management/bond-requests/:id/state`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_BOND_TYPE_TO_CHANGE_STATE',
    },
    {
      tag: enumRespErrors.CannotDetachDefaultContact,
      url: `${environment.url.prefixCustoms}v2/management/brokers/:brokerId/contacts/:contactId`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.CANNOT_DETACH_DEFAULT_CONTACT',
    },
    {
      tag: enumRespErrors.ContactAlreadyAttached,
      url: `${environment.url.prefixCustoms}v2/management/brokers/:brokerId/contacts/:contactId`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.CONTACT_ALREADY_ATTACHED_BROKER',
    },
    {
      tag: enumRespErrors.DefaultContactIsNotAttached,
      url: `${environment.url.prefixCustoms}v2/management/brokers/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.DEFAULT_CONTACT_IS_NOT_ATTACHED_BROKER',
    },
    {
      tag: enumRespErrors.InvalidCredentials,
      url: `${environment.url.prefixCustoms}v2/management/companies/:id/credentials`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.INVALID_CREDENTIALS',
    },
    {
      tag: enumRespErrors.StartDateInPast,
      url: `${environment.url.prefixCustoms}v2/management/discounts`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.START_DATE_IN_PAST_CREATE',
    },
    {
      tag: enumRespErrors.StartDateInPast,
      url: `${environment.url.prefixCustoms}v2/management/discounts/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.START_DATE_IN_PAST_UPDATE',
    },
    {
      tag: enumRespErrors.StartDateInPast,
      url: `${environment.url.prefixCustoms}v2/management/discounts/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.START_DATE_IN_PAST_DELETE',
    },
    {
      tag: enumRespErrors.CouponNotUnique,
      url: `${environment.url.prefixCustoms}v2/management/discounts`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.COUPON_IS_NOT_UNIQUE',
    },
    {
      tag: enumRespErrors.CouponNotUnique,
      url: `${environment.url.prefixCustoms}v2/management/discounts/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.COUPON_IS_NOT_UNIQUE',
    },
    {
      tag: enumRespErrors.WrongEntityState,
      url: `${environment.url.prefixCustoms}v2/management/entry-summaries/:id/state`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_ENTITY_STATE',
    },
    {
      tag: enumRespErrors.EntrySummaryAlreadySent,
      url: `${environment.url.prefixCustoms}v2/management/entry-summaries/:id/update-broker-and-affiliate`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTRY_SUMMARY_ALREADY_SENT',
    },
    {
      tag: enumRespErrors.PaymentTypeCannotBeChangedToAch,
      url: `${environment.url.prefixCustoms}v2/management/entry-summaries/:id/duties-payment-type`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.PAYMENT_TYPE_CANNOT_BE_CHANGED_TO_ACH',
    },
    {
      tag: enumRespErrors.PaymentTypeAlreadyEqualToNewValue,
      url: `${environment.url.prefixCustoms}v2/management/entry-summaries/:id/duties-payment-type`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.PAYMENT_TYPE_ALREADY_EQUAL_TO_NEW_VALUE',
    },
    {
      tag: enumRespErrors.WrongEntrySummaryState,
      url: `${environment.url.prefixCustoms}v2/management/entry-summaries/:id/duties-payment-type`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_ENTRY_SUMMARY_STATE',
    },
    {
      tag: enumRespErrors.EntrySummaryAlreadyHasStatement,
      url: `${environment.url.prefixCustoms}v2/management/entry-summaries/:id/duties-payment-type`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTRY_SUMMARY_ALREADY_HAS_STATEMENT',
    },
    {
      tag: enumRespErrors.WrongEntityState,
      url: `${environment.url.prefixCustoms}v3/management/isfs/:id/state`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.WRONG_ENTITY_STATE',
    },
    {
      tag: enumRespErrors.EventAlreadySyncronized,
      url: `${environment.url.prefixCustoms}v2/management/lds-connections/:id/lastProviderEventId`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.EVENT_ALREADY_SYNCRONIZED',
    },
    {
      tag: enumRespErrors.InvalidCredentials,
      url: `${environment.url.prefixCustoms}v2/management/lds-connections`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVALID_CREDENTIALS',
    },
    {
      tag: enumRespErrors.InvalidCredentials,
      url: `${environment.url.prefixCustoms}v2/management/lds-connections/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.INVALID_CREDENTIALS',
    },
    {
      tag: enumRespErrors.BillIsNotPaidOrRefunded,
      url: `${environment.url.prefixCustoms}v2/management/bills/{billId}/refund-data`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.BILL_IS_NOT_PAID_OR_REFUNDED',
    },
    {
      tag: enumRespErrors.ProductDetailsDoesNotExist,
      url: `${environment.url.prefixCustoms}v2/management/products/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.PRODUCT_DETAILS_DOES_NOT_EXIST',
    },
    {
      tag: enumRespErrors.EffectiveDateInPast,
      url: `${environment.url.prefixCustoms}v2/management/product-details`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.EFFECTIVE_DATE_IN_PAST_CREATE',
    },
    {
      tag: enumRespErrors.EffectiveDateInPast,
      url: `${environment.url.prefixCustoms}v2/management/product-details/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.EFFECTIVE_DATE_IN_PAST_UPDATE',
    },
    {
      tag: enumRespErrors.EffectiveDateInPast,
      url: `${environment.url.prefixCustoms}v2/management/product-details/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.EFFECTIVE_DATE_IN_PAST_DELETE',
    },
    {
      tag: enumRespErrors.InvalidEntrySummary,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/pending-bills`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.INVALID_ENTRY_SUMMARY',
    },
    {
      tag: enumRespErrors.InvalidEntrySummary,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/cancelled-bills`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.INVALID_ENTRY_SUMMARY',
    },
    {
      tag: enumRespErrors.InvalidEntrySummary,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/bills`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVALID_ENTRY_SUMMARY',
    },
    {
      tag: enumRespErrors.InvalidIsf,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/pending-bills`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.INVALID_ISF',
    },
    {
      tag: enumRespErrors.InvalidIsf,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/cancelled-bills`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.INVALID_ISF',
    },
    {
      tag: enumRespErrors.InvalidIsf,
      url: `${environment.url.prefixCustoms}v2/companies/:companyId/bills`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVALID_ISF',
    },
    {
      tag: enumRespErrors.BillIsOutdated,
      url: `${environment.url.prefixCustoms}v2/payments`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.BILL_IS_OUTDATED',
    },
    {
      tag: enumRespErrors.BillIsAlreadyPaid,
      url: `${environment.url.prefixCustoms}v2/payments`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.BILL_IS_ALREADY_PAID',
    },
    {
      tag: enumRespErrors.InvoiceAlreadyExists,
      url: `${environment.url.prefixCustoms}v2/management/bills/:billId/silent-sap-invoice`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVOICE_ALREADY_EXISTS',
    },
    {
      tag: enumRespErrors.WrongState,
      url: `${environment.url.prefixCustoms}v2/statements/authorized/:id`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.WRONG_STATE_STATEMENT',
    },
    {
      tag: enumRespErrors.StatementIsSharedBetweenUsers,
      url: `${environment.url.prefixCustoms}v2/statements/authorized/:id`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.STATEMENT_IS_SHARED_BETWEEN_USERS',
    },
    {
      tag: enumRespErrors.UserCannotBeDeleted,
      url: `${environment.url.prefixCustoms}v2/users`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.USER_CANNOT_BE_DELETED',
    },
    {
      tag: enumRespErrors.MasterAndHouseBlsAreRequired,
      url: `${environment.url.prefixCustoms}management/bill-queries`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.MASTER_AND_HOUSE_BLS_ARE_REQUIRED',
    },
    {
      tag: enumRespErrors.MasterBlAreRequired,
      url: `${environment.url.prefixCustoms}management/bill-queries`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.MASTER_BL_ARE_REQUIRED',
    },
    {
      tag: enumRespErrors.BlAreRequired,
      url: `${environment.url.prefixCustoms}management/bill-queries`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.BL_ARE_REQUIRED',
    },
    {
      tag: enumRespErrors.InvalidBill,
      url: `${environment.url.prefixCustoms}management/bill-queries`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.INVALID_BILL',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/isfs/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}isfs/:id/bond`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}isfs/:id/bond-request-id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}isfs/:id/bond-request-id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },

    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:id/bond`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:id/bond-request-id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:id/bond-request-id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },

    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/entities/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/entities/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },

    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/entry-summaries/:entrySummaryId/shipments`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/shipments/:id`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/shipments/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/shipments/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },

    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/shipments/:shipmentId/invoices`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/invoices/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/invoices/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },

    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/invoices/:invoiceId/line-items`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/line-items/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/line-items/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      // a description change would end a classification assistant conversation whose turn is still running (#13383)
      tag: enumRespErrors.HtsChatTurnInProgress,
      url: `${environment.url.prefixCustoms}v2/line-items/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.HTS_CHAT_TURN_IN_PROGRESS',
    },

    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/bond-requests/:id`,
      method: HttpMethod.PUT,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityIsLocked,
      url: `${environment.url.prefixCustoms}v2/bond-requests/:id`,
      method: HttpMethod.DELETE,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_LOCKED',
    },
    {
      tag: enumRespErrors.EntityNotFromUs,
      isGlobal: true,
      errorText: 'KNOWN_ERRORS.ENTITY_NOT_FROM_US',
    },
    {
      tag: enumRespErrors.ImporterAndConsigneeAreForeign,
      isGlobal: true,
      errorText: 'KNOWN_ERRORS.IMPORTER_AND_CONSIGNEE_ARE_FOREIGN',
    },
    {
      tag: enumRespErrors.EntityIsNotFound,
      url: `${environment.url.prefixInsurance}shipments`,
      method: HttpMethod.GET,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_NOT_FOUND',
      isSkip: true,
    },
    {
      tag: enumRespErrors.UserExists,
      url: `${environment.url.prefixFreight}external-manual-quotes`,
      method: HttpMethod.POST,
      errorText: 'KNOWN_ERRORS.ENTITY_IS_NOT_FOUND',
      isSkip: true,
    },
  ];
};
